import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ArticleSidebar = ({ blog }) => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e?.preventDefault();
    if (email) {
      console.log('Subscribe email:', email);
      setSubscribed(true);
      setTimeout(() => {
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  return (
    <div className="space-y-6 lg:sticky lg:top-8">
      {/* Author Bio */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">About the Author</h3>
        <div className="flex items-start gap-4">
          {blog?.author?.avatarUrl && (
            <Image
              src={blog?.author?.avatarUrl}
              alt={blog?.author?.fullName}
              className="w-16 h-16 rounded-full object-cover"
            />
          )}
          <div className="flex-1">
            <h4 className="font-semibold text-foreground mb-1">{blog?.author?.fullName}</h4>
            <p className="text-sm text-muted-foreground mb-3">
              Content creator and developer sharing insights on web development, design, and technology.
            </p>
            <div className="flex gap-2">
              <Button variant="ghost" size="sm" className="p-2">
                <Icon name="Twitter" size={16} />
              </Button>
              <Button variant="ghost" size="sm" className="p-2">
                <Icon name="Linkedin" size={16} />
              </Button>
              <Button variant="ghost" size="sm" className="p-2">
                <Icon name="Github" size={16} />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Signup */}
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-6">
        <div className="flex items-center gap-2 mb-3">
          <Icon name="Mail" size={20} color="var(--color-accent)" />
          <h3 className="text-lg font-semibold text-foreground">Stay Updated</h3>
        </div>
        <p className="text-sm text-muted-foreground mb-4">
          Get the latest articles and insights delivered to your inbox.
        </p>
        {subscribed ? (
          <div className="flex items-center gap-2 text-green-600 bg-green-50 p-3 rounded-md">
            <Icon name="CheckCircle" size={18} />
            <span className="text-sm font-medium">Successfully subscribed!</span>
          </div>
        ) : (
          <form onSubmit={handleSubscribe} className="space-y-3">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e?.target?.value)}
              required
              className="w-full px-4 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-accent bg-background text-foreground"
            />
            <Button type="submit" variant="default" className="w-full">
              Subscribe
            </Button>
          </form>
        )}
      </div>

      {/* Table of Contents (Desktop) */}
      <div className="hidden lg:block bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Table of Contents</h3>
        <nav className="space-y-2 text-sm">
          <a href="#" className="block text-muted-foreground hover:text-accent transition-colors">
            Introduction
          </a>
          <a href="#" className="block text-muted-foreground hover:text-accent transition-colors pl-3">
            Key Concepts
          </a>
          <a href="#" className="block text-muted-foreground hover:text-accent transition-colors pl-3">
            Implementation
          </a>
          <a href="#" className="block text-muted-foreground hover:text-accent transition-colors">
            Conclusion
          </a>
        </nav>
      </div>
    </div>
  );
};

export default ArticleSidebar;